import type { FC } from "react";

export const PageEatenIllustration: FC = () => (
  <svg
    width="500"
    height="581"
    viewBox="0 0 500 581"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_9842_36497)">
      <path
        d="M29.917 501.583C29.917 501.583 81.908 539.034 97.38 539.034L108.431 534.616L121.131 535.367L124.084 544.376L143.796 547.869L137.165 554.495L159.268 560.017L172.53 551.182L176.95 556.704L192.422 551.182L196.124 560.017L214.525 553.391L226.682 557.809C226.682 557.809 228.892 571.061 239.943 572.166C250.995 573.27 266.467 581.001 266.467 581.001L300.963 566.255L305.146 558.913L317.303 562.226L349.352 544.556C349.352 544.556 348.64 544.654 340.155 541.292C331.67 537.93 330.565 533.512 330.565 533.512L324.548 535.367C324.548 535.367 315.074 532.743 321.714 521.531C328.354 510.32 323.131 511.879 323.131 511.879L312.882 514.738L307.357 505.902C307.357 505.902 296.305 509.216 294.095 510.32C291.885 511.424 297.411 504.798 297.411 504.798L292.99 502.589L294.095 497.067C294.095 497.067 290.78 494.859 295.2 490.441C299.621 486.024 291.885 481.606 291.885 481.606C291.885 481.606 271.658 488.115 279.009 477.13C286.359 466.145 279.947 461.731 279.947 461.731L230.897 446.266L225.576 453.996C225.576 453.996 208.075 449.256 213.51 463.775C213.51 463.775 201.462 464.764 205.783 471.528C205.783 471.528 191.317 469.705 194.632 478.417L182.923 475.164C182.923 475.164 173.981 472.495 180.991 471.528C188.002 470.562 178.415 467.801 178.415 467.801C178.415 467.801 181.551 455.653 172.62 459.242C163.688 462.831 156.14 467.801 156.14 467.801L29.917 501.583Z"
        fill="#B3B3B3"
      />
      <path
        d="M33.2324 497.165C33.2324 497.165 85.2235 534.616 100.695 534.616L111.747 530.199L124.446 530.949L127.4 539.958L147.111 543.451L140.481 550.077L162.583 555.599L175.845 546.764L180.266 552.286L195.738 546.764L199.439 555.599L217.84 548.973L229.997 553.391C229.997 553.391 232.207 566.643 243.259 567.748C254.31 568.852 269.782 576.583 269.782 576.583L304.279 561.837L308.462 554.495L320.618 557.808L352.668 540.138C352.668 540.138 351.956 540.236 343.471 536.874C334.985 533.512 333.88 529.094 333.88 529.094L327.864 530.949C327.864 530.949 318.39 528.325 325.03 517.113C331.67 505.902 326.447 507.461 326.447 507.461L316.198 510.32L310.672 501.484C310.672 501.484 299.621 504.798 297.411 505.902C295.2 507.006 300.726 500.38 300.726 500.38L296.305 498.171L297.411 492.649C297.411 492.649 294.095 490.441 298.516 486.023C302.936 481.606 295.2 477.188 295.2 477.188C295.2 477.188 274.973 483.697 282.324 472.712C289.675 461.727 283.262 457.313 283.262 457.313L234.212 441.848L228.892 449.578C228.892 449.578 211.391 444.838 216.826 459.357C216.826 459.357 204.777 460.346 209.098 467.11C209.098 467.11 194.632 465.287 197.948 473.999L186.238 470.746C186.238 470.746 177.296 468.077 184.307 467.11C191.317 466.144 181.731 463.383 181.731 463.383C181.731 463.383 184.867 451.235 175.935 454.824C167.004 458.413 159.455 463.383 159.455 463.383L33.2324 497.165Z"
        fill="#D6D6E3"
      />
      <path
        d="M404.61 372.272C404.61 372.272 446.605 362.332 442.184 321.47L449.92 323.679V308.273C449.92 308.273 465.303 333.618 465.347 343.558C465.392 353.497 472.023 425.282 392.453 412.03L404.61 372.272Z"
        fill="#0F5156"
      />
      <path
        d="M178.055 29.9112L167.557 30.4633H150.847C150.847 30.4633 138.915 27.7024 134.725 29.9112L140.481 33.2243C140.481 33.2243 130.534 34.3287 127.219 38.7462H136.468C136.468 38.7462 123.904 42.0594 121.693 50.8945C119.483 59.7296 97.3802 79.6085 97.3802 79.6085C97.3802 79.6085 52.0694 116.053 107.326 165.751C107.326 165.751 113.957 186.734 111.747 190.047C109.537 193.36 139.376 197.778 142.691 174.586C146.006 151.394 152.637 102.801 152.637 97.2787C152.637 91.7568 167.004 57.5208 167.004 57.5208"
        fill="#0F5156"
      />
      <path
        d="M312.883 29.9112L323.382 30.4633H340.091C340.091 30.4633 352.023 27.7024 356.213 29.9112L350.458 33.2243C350.458 33.2243 360.404 34.3287 363.719 38.7462H354.47C354.47 38.7462 367.035 42.0594 369.245 50.8945C371.455 59.7296 393.558 79.6085 393.558 79.6085C393.558 79.6085 438.869 116.053 383.612 165.751C383.612 165.751 376.981 186.734 379.191 190.047C381.402 193.36 351.563 197.778 348.247 174.586C344.932 151.394 338.301 102.801 338.301 97.2787C338.301 91.7568 323.934 57.5208 323.934 57.5208"
        fill="#0F5156"
      />
      <path
        d="M401.849 411.476C399.639 422.52 389.692 430.251 389.692 430.251C385.272 457.861 366.484 445.712 366.484 445.712C365.379 450.13 344.382 447.921 344.382 447.921L341.066 443.559V456.756C341.066 466.696 327.804 463.383 327.804 463.383C324.489 473.322 304.276 467.8 304.276 467.8C296.23 474.426 281.389 467.8 281.389 467.8C261.496 466.696 259.286 450.13 259.286 450.13L262.601 421.416L242.719 421.835C220.617 441.019 197.95 423.812 197.95 423.812C197.95 423.812 194.082 443.504 191.872 453.443C189.662 463.382 159.513 460.599 159.513 460.599C152.574 467.756 137.996 459.362 137.996 459.362C126.105 464.167 118.933 453.443 118.933 453.443C102.356 437.982 132.891 413.442 132.891 413.442V356.169C120.325 305.267 138.273 211.384 138.273 211.384C139.754 207.032 142.472 203.818 145.555 201.466C152.772 195.911 161.989 195.017 161.989 195.017C161.989 195.017 312.332 181.764 334.435 183.973C338.613 184.392 341.962 187.131 344.636 191.306C356.163 209.23 355.433 253.549 355.433 253.549C377.536 263.489 383.061 312.082 383.061 312.082C433.898 329.752 404.059 400.433 401.849 411.476Z"
        fill="#0F5156"
      />
      <path
        d="M316.75 24.9419C316.75 24.9419 238.285 -34.695 167.556 30.4638C167.556 30.4638 118.377 152.498 137.165 181.212C155.952 209.926 211.46 234.313 211.46 234.313C211.46 234.313 247.228 242.134 280.608 234.313C313.987 226.492 350.457 173.482 350.457 173.482C350.457 173.482 351.562 34.3292 316.75 24.9419Z"
        fill="#0F5156"
      />
      <path
        d="M269.354 70.1116C274.291 80.7181 284.045 88.8042 295.351 91.7916C297.415 92.3372 298.296 89.1423 296.232 88.5968C285.685 85.8098 276.813 78.3142 272.217 68.4393C271.318 66.5079 268.459 68.1885 269.354 70.1116Z"
        fill="#090814"
      />
      <path
        d="M210.679 69.7281C208.425 75.5101 204.809 80.7109 200.242 84.9075C198.009 86.9596 195.534 88.7977 192.865 90.2468C190.038 91.7815 186.42 93.0399 183.379 91.3835C181.505 90.3628 179.829 93.2226 181.706 94.2443C188.559 97.9772 196.518 92.5195 201.619 88.1119C207.09 83.3839 211.255 77.3315 213.876 70.6089C214.651 68.6212 211.446 67.7599 210.679 69.7281Z"
        fill="#090814"
      />
      <path
        d="M296.306 140.35C307.292 140.35 316.198 131.45 316.198 120.471C316.198 109.492 307.292 100.592 296.306 100.592C285.319 100.592 276.413 109.492 276.413 120.471C276.413 131.45 285.319 140.35 296.306 140.35Z"
        fill="white"
      />
      <path
        d="M294.095 134.829C302.64 134.829 309.567 127.907 309.567 119.368C309.567 110.829 302.64 103.906 294.095 103.906C285.55 103.906 278.623 110.829 278.623 119.368C278.623 127.907 285.55 134.829 294.095 134.829Z"
        fill="#090814"
      />
      <path
        d="M297.963 114.398C299.794 114.398 301.278 112.914 301.278 111.085C301.278 109.255 299.794 107.771 297.963 107.771C296.132 107.771 294.647 109.255 294.647 111.085C294.647 112.914 296.132 114.398 297.963 114.398Z"
        fill="white"
      />
      <path
        d="M197.948 141.455C208.935 141.455 217.841 132.555 217.841 121.576C217.841 110.597 208.935 101.697 197.948 101.697C186.962 101.697 178.056 110.597 178.056 121.576C178.056 132.555 186.962 141.455 197.948 141.455Z"
        fill="white"
      />
      <path
        d="M195.738 135.933C204.283 135.933 211.21 129.01 211.21 120.471C211.21 111.932 204.283 105.01 195.738 105.01C187.193 105.01 180.266 111.932 180.266 120.471C180.266 129.01 187.193 135.933 195.738 135.933Z"
        fill="#090814"
      />
      <path
        d="M199.605 115.501C201.437 115.501 202.921 114.018 202.921 112.188C202.921 110.358 201.437 108.875 199.605 108.875C197.774 108.875 196.29 110.358 196.29 112.188C196.29 114.018 197.774 115.501 199.605 115.501Z"
        fill="white"
      />
      <path
        d="M242.706 195.017C242.706 195.017 207.341 183.973 216.183 162.99C225.024 142.006 252.652 149.737 252.652 149.737C252.652 149.737 276.413 153.602 269.354 171.681C264.256 184.525 255.968 190.599 242.706 195.017Z"
        fill="#090814"
      />
      <path
        d="M198.073 228.845L197.821 226.651C197.928 226.638 208.604 225.281 218.124 214.711C226.725 205.161 237.965 204.199 241.608 204.154L241.601 195.02L243.811 195.018L243.821 206.449L242.646 206.377C242.512 206.369 229.219 205.695 219.767 216.189C209.656 227.415 198.54 228.792 198.073 228.845Z"
        fill="#090814"
      />
      <path
        d="M293.767 230.021C292.964 229.771 274.041 223.808 269.682 215.305C266.474 209.05 249.084 206.74 242.652 206.376L242.778 204.172C243.773 204.228 267.213 205.646 271.648 214.298C275.59 221.984 294.236 227.854 294.423 227.912L293.767 230.021Z"
        fill="#090814"
      />
      <path
        d="M198.943 424.288L196.953 423.326C218.54 378.742 197.195 338.332 196.977 337.93L198.92 336.877C199.144 337.29 221.037 378.657 198.943 424.288Z"
        fill="#090814"
      />
      <path
        d="M261.496 421.482C259.848 393.49 270.803 343.817 270.913 343.318L273.072 343.797C272.962 344.293 262.072 393.668 263.702 421.352L261.496 421.482Z"
        fill="#090814"
      />
      <path
        d="M339.552 444.605L330.711 429.144C321.698 413.381 344.067 361.867 345.025 359.682L347.049 360.566C346.992 360.699 341.213 373.951 336.588 388.906C330.54 408.465 329.172 422.001 332.63 428.048L341.471 443.509L339.552 444.605Z"
        fill="#090814"
      />
      <path
        d="M367.566 445.931L365.398 445.497C368.085 432.073 366.446 421.699 366.429 421.596L368.61 421.238C368.683 421.675 370.336 432.088 367.566 445.931Z"
        fill="#090814"
      />
      <path
        d="M343.31 448.203C340.503 437.545 344.788 421.788 344.971 421.123L347.102 421.71C347.058 421.867 342.793 437.563 345.447 447.64L343.31 448.203Z"
        fill="#090814"
      />
      <path
        d="M282.461 468.056L280.312 467.544C283.003 456.245 281.952 438.778 281.941 438.603L284.147 438.465C284.192 439.193 285.231 456.433 282.461 468.056Z"
        fill="#090814"
      />
      <path
        d="M305.366 468.004L303.192 467.599C304.498 460.616 304.047 442.063 304.042 441.876L306.252 441.82C306.271 442.591 306.714 460.794 305.366 468.004Z"
        fill="#090814"
      />
      <path
        d="M328.905 463.449L326.699 463.32C327.232 454.249 324.014 444.505 323.981 444.408L326.077 443.707C326.217 444.121 329.464 453.958 328.905 463.449Z"
        fill="#090814"
      />
      <path
        d="M158.415 460.691C157.537 450.511 166.087 434.801 166.451 434.137L168.389 435.199C168.303 435.357 159.796 450.987 160.616 460.501L158.415 460.691Z"
        fill="#090814"
      />
      <path
        d="M136.9 459.524C135.476 450.266 143.859 434.795 144.216 434.141L146.157 435.2C146.072 435.353 137.775 450.669 139.084 459.19L136.9 459.524Z"
        fill="#090814"
      />
      <path
        d="M122.243 458.304C119.746 457.076 119.774 452.794 122.331 444.827C124.058 439.446 126.368 434.269 126.391 434.219L128.409 435.12C124.285 444.329 121.139 455.299 123.219 456.322L122.243 458.304Z"
        fill="#090814"
      />
      <path
        d="M41.0291 455.928C41.0291 455.928 51.0217 466.143 66.4649 465.591C66.4649 465.591 59.8053 479.396 32.1767 482.709C32.1767 482.709 20.0202 476.083 12.2842 476.083C4.5482 476.083 -0.95543 466.143 0.138673 465.591C1.23278 465.039 16.7048 467.248 16.7048 467.248L41.0291 455.928Z"
        fill="#B3B3B3"
      />
      <path
        d="M41.0291 453.719C41.0291 453.719 51.0217 463.934 66.4649 463.382C66.4649 463.382 59.8053 477.187 32.1767 480.5C32.1767 480.5 20.0202 473.874 12.2842 473.874C4.5482 473.874 -0.95543 463.934 0.138673 463.382C1.23278 462.83 16.7048 465.039 16.7048 465.039L41.0291 453.719Z"
        fill="#D6D6E3"
      />
      <path
        d="M97.3799 492.65L163.437 470.746L235.523 495.963L169.214 523.573L97.3799 492.65Z"
        fill="#B3B3B3"
      />
      <path
        d="M224.392 467.11L228.255 463.383L277.517 480.501L275.307 483.814L224.392 467.11Z"
        fill="#B3B3B3"
      />
      <path
        d="M202.859 473.599L207.771 470.746L289.43 497.159V500.061L202.859 473.599Z"
        fill="#B3B3B3"
      />
      <path
        d="M241.049 502.589L244.677 500.061L309.568 521.363L305.228 524.835L241.049 502.589Z"
        fill="#B3B3B3"
      />
      <path
        d="M222.139 512.448L224.392 509.215L289.431 532.235L286.36 535.72L222.139 512.448Z"
        fill="#B3B3B3"
      />
      <path
        d="M206.789 519.155L207.771 516.148L271.992 539.958L268.677 541.243L206.789 519.155Z"
        fill="#B3B3B3"
      />
      <path
        d="M197.948 527.409L202.86 523.572L235.523 538.027L233.73 541.242L197.948 527.409Z"
        fill="#B3B3B3"
      />
      <path
        d="M85.2236 501.485L88.1981 500.061L146.797 522.468L143.577 523.572L85.2236 501.485Z"
        fill="#B3B3B3"
      />
      <path
        d="M71.9619 504.798L78.5928 501.484L110.642 518.05L107.326 520.259L71.9619 504.798Z"
        fill="#B3B3B3"
      />
      <path
        d="M332.977 472.219L334.986 486.024L331.18 495.47L341.165 499.974L349.353 510.914V516.866L369.798 521.853C369.798 521.853 381.402 537.93 389.138 535.721C396.874 533.512 457.596 489.821 457.596 489.821L345.228 467.801C345.228 467.801 332.073 465.04 332.977 472.219Z"
        fill="#B3B3B3"
      />
      <path
        d="M329.662 467.801L331.67 481.606L327.864 491.051L337.849 495.556L346.037 506.496V512.448L366.482 517.435C366.482 517.435 378.086 533.512 385.822 531.303C393.558 529.094 454.28 485.403 454.28 485.403L341.912 463.383C341.912 463.383 328.758 460.622 329.662 467.801Z"
        fill="#D6D6E3"
      />
      <path
        d="M339.658 485.403L343.471 481.398L396.969 497.159L395.037 500.06L339.658 485.403Z"
        fill="#B3B3B3"
      />
      <path
        d="M352.668 501.99L354.147 497.186L380.296 507.006L378.939 511.816L352.668 501.99Z"
        fill="#B3B3B3"
      />
      <path
        d="M463.289 434.979C463.289 434.979 451.957 450.682 434.361 442.951C434.361 442.951 427.939 447.368 425.668 448.473C423.397 449.577 408.604 450.129 408.604 450.129L429.532 457.584L442.184 465.039L472.023 460.621C472.023 460.621 478.654 455.099 485.285 455.099C491.915 455.099 497.79 442.951 497.79 442.951C497.79 442.951 478.75 441.847 478.149 439.086C477.549 436.325 468.922 442.468 463.289 434.979Z"
        fill="#B3B3B3"
      />
      <path
        d="M460.763 533.113C462.076 540.138 490.384 526.84 490.384 526.84L478.471 520.566L473.128 519.155H465.27C465.27 519.155 458.64 513.472 452.069 516.866C452.069 516.866 459.449 526.088 460.763 533.113Z"
        fill="#B3B3B3"
      />
      <path
        d="M465.499 430.562C465.499 430.562 454.167 446.266 436.571 438.535C436.571 438.535 430.149 442.952 427.878 444.057C425.607 445.161 410.813 445.713 410.813 445.713L431.742 453.168L444.394 460.623L474.233 456.205C474.233 456.205 480.864 450.683 487.494 450.683C494.125 450.683 500 438.535 500 438.535C500 438.535 480.96 437.431 480.359 434.67C479.758 431.909 471.132 438.052 465.499 430.562Z"
        fill="#D6D6E3"
      />
      <path
        d="M462.973 528.695C464.287 535.72 492.595 522.422 492.595 522.422L480.682 516.148L475.338 514.737H467.481C467.481 514.737 460.851 509.054 454.28 512.448C454.28 512.448 461.66 521.67 462.973 528.695Z"
        fill="#D6D6E3"
      />
      <path
        d="M100.322 493.322C100.322 493.322 150.141 487.826 159.215 491.402L162.398 520.044L100.322 493.322Z"
        fill="white"
      />
      <path
        d="M182.655 498.291C187.537 498.291 191.496 496.561 191.496 494.426C191.496 492.291 187.537 490.561 182.655 490.561C177.772 490.561 173.813 492.291 173.813 494.426C173.813 496.561 177.772 498.291 182.655 498.291Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_9842_36497">
        <rect width="500" height="581" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
